export const AUTONOMOUS_ENROLL_TYPES = ["PRE_AUTO", "PRE_BOTTOM"];

export const isAutonomousEnrollType = (enrollType?: string | null): boolean =>
  !!enrollType && AUTONOMOUS_ENROLL_TYPES.includes(enrollType);
